export default __webpack_public_path__ + "measure-800-538cc6b4ba03855ab73371d8c22a6bef.webp";